import { isDevModeAllowed } from '@lykbl/dev-tools';

/**
 * Whether the dev-mode tooling (mock sessions, staging auth gate, indicator)
 * is mounted. Evaluated once in the browser; always false during prerender.
 *
 * DevModeProvider and DevModeAuthGate render nothing on their first pass, so a
 * tree that includes them can never hydrate server HTML — main.tsx falls back
 * to a plain client render whenever this is true (localhost, staging).
 * On lykbl.com it is false, which matches the previous behaviour: dev mode was
 * already disabled there and both wrappers only passed their children through.
 */
export const DEV_TOOLS_ENABLED: boolean = typeof window !== 'undefined' && isDevModeAllowed();
